/**
 * Osobný kľúč pre program Tandem Zostavy (KOLO 128).
 *
 * Celý kľúč vráti len vygenerovanie — `GET` ukáže iba jeho začiatok
 * a kedy ho program naposledy použil. Server ukladá len odtlačok.
 */
import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import type { DataResponse } from "@/api/schemas";

export interface MojKluc {
  existuje: boolean;
  prefix: string | null;
  created_at: string | null;
  last_used_at: string | null;
}

export interface NovyKluc {
  /** Celý kľúč — ukáže sa len teraz. */
  kluc: string;
  prefix: string;
  created_at: string;
}

export function useMojKluc(enabled = true): UseQueryResult<DataResponse<MojKluc>> {
  return useQuery({
    queryKey: queryKeys.mojKluc.all,
    queryFn: async () => {
      const { data } = await api.get<DataResponse<MojKluc>>("/moj-kluc");
      return data;
    },
    enabled,
  });
}

export function useVygenerujKluc(): UseMutationResult<
  DataResponse<NovyKluc>,
  Error,
  void
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data } = await api.post<DataResponse<NovyKluc>>("/moj-kluc");
      return data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: queryKeys.mojKluc.all }),
  });
}

export function useZrusKluc(): UseMutationResult<void, Error, void> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await api.delete("/moj-kluc");
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: queryKeys.mojKluc.all }),
  });
}
